import { useEffect, useMemo } from "react";
import {
  CartesianGrid,
  Label,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { CustomTooltipContent } from "./CustomTooltipContent";
import { transformChartData } from "./asessment-constant";

type AssessmentLineChartProps = {
  data: any;
  assessmentConfig: Record<string, { color: string; label: string }>;
};

const AssessmentLineChart = ({
  data,
  assessmentConfig,
}: AssessmentLineChartProps) => {
  useEffect(() => {}, []);

  const a = Object.entries(data ?? {}).map(([displayDate, allAssessments]) => {
    return {
      displayDate,
      allAssessments,
    };
  });

  const chartData = useMemo(() => transformChartData(a as any), [a]);

  useEffect(() => {}, [chartData]);

  return (
    <ResponsiveContainer>
      <LineChart
        data={chartData}
        margin={{ top: 5, right: 30, left: 0, bottom: 5 }}
      >
        {/* <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" /> */}
        <CartesianGrid strokeDasharray="1" vertical={false} />

        <XAxis
          dataKey="displayDate"
          tick={{ fontSize: 12 }}
          interval="preserveStartEnd"
        />
        <YAxis
          domain={[0, 5]}
          // ticks={Array.from({ length: 193 }, (_, i) => i)}
          ticks={[0, 1, 2, 3, 4]}
          tick={{ fontSize: 12 }}
          label={{
            value: "Alert Level",
            position: "insideLeft",
            angle: -90,
            offset: 10,
          }}
        />

        {!chartData?.length && (
          <Label value="No Submitted Assessment" position="center" />
        )}

        <Tooltip
          wrapperStyle={{ pointerEvents: "auto" }}
          content={(props) => <CustomTooltipContent {...props} />}
        />

        {Object.entries(assessmentConfig ?? {}).map(([name, config]) => (
          <Line
            key={name}
            type="monotone"
            dataKey={name}
            stroke={config.color}
            strokeWidth={2}
            dot={<CustomDot stroke={config.color} />}
            connectNulls={true}
            isAnimationActive={false}
          />
        ))}
      </LineChart>
    </ResponsiveContainer>
  );
};

export default AssessmentLineChart;

const CustomDot = (props: any) => {
  const { cx, cy, value } = props;

  if (value === null || value === undefined || value < 0.5) return null;

  return <circle cx={cx} cy={cy} r={2} fill={props.stroke} />;
};
